import { CustomField } from '@models';

export interface ProductItem {
  id: number;
  sku?: string;
  name?: string;
  brand?: string;
  categories?: string[];
  sort_order: number;
  custom_fields?: CustomField[];
}

const cleanSorting = (input: ProductItem[]): ProductItem[] => {
  if (input.length) {
    input.sort((a, b) => a.sort_order - b.sort_order);
    return input.map((item, index) => ({ ...item, sort_order: index + 1 }));
  }

  return input;
};

const changeToNewRanking = (prodListItems: ProductItem[] | undefined, id: number, targetInput: string) => {
  if (prodListItems) {
    const prodList = cleanSorting(prodListItems);
    const target = parseInt(targetInput) > prodList.length ? prodList.length : parseInt(targetInput);

    const origItemIndex = prodList.findIndex((item) => {
      return item.id === id;
    });
    const targetItemIndex = prodList.findIndex((item) => {
      return item.sort_order === target;
    });

    if (origItemIndex > targetItemIndex) {
      for (let i = origItemIndex - 1; i > targetItemIndex - 1; i--) {
        prodList[i].sort_order++;
      }
    } else {
      for (let i = origItemIndex + 1; i < targetItemIndex + 1; i++) {
        prodList[i].sort_order--;
      }
    }

    prodList[origItemIndex].sort_order = target;

    prodList.sort((a, b) => {
      return a.sort_order - b.sort_order;
    });

    return prodList;
  }

  return prodListItems;
};

const findChangedProductsList = (originalList: ProductItem[], changedList: ProductItem[]): ProductItem[] => {
  const differentProducts = [];

  for (let i = 0; i < originalList.length; i++) {
    const changedProduct = findProductById(changedList, originalList[i].id);

    if (originalList[i].sort_order !== changedProduct?.sort_order) {
      if (changedProduct) {
        differentProducts.push(changedProduct);
      }
    }
  }

  return differentProducts;
};

const findProductById = (list: ProductItem[], id: number) => {
  return list.find((item: ProductItem) => {
    return item.id === id;
  });
};

export { cleanSorting, changeToNewRanking, findChangedProductsList };
